import { QUERY_KEYS } from "@/constants/queryKeys";
import { subscribeProductHandoff } from "@/utils/productHandoff";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

/**
 * Refetches everything a product hand-off can invalidate once the product tab reports back.
 *
 * The hand-off provisions the admin's product account in the product tab, so this tab would keep
 * rendering a stale useMe().productAccounts (sending the admin back through the first-login modal)
 * and a stale contract list.
 */
export const useProductHandoffSync = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return subscribeProductHandoff(() => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER.FETCH_ME] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PRODUCT_CONTRACT.FETCH_LIST_BY_ORGANIZATION] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ORGANIZATION.FETCH_DETAIL] });
    });
  }, [queryClient]);
};
